import React from 'react';
import { RepositoryActions } from '../../modules/repository/actions';
import { RepositoryFilters } from '../index';

const NewOrSearchBox = ({
  search,
  filter,
  onFilterChange,
  onSearchChange,
  onNewFolderCreate,
}) => {
  return (
    <>
      <RepositoryActions />
      <RepositoryFilters
        filter={filter}
        onFilterChange={onFilterChange}
        search={search}
        onSearchChange={onSearchChange}
        onNewFolderCreate={onNewFolderCreate}
      />
    </>
  );
};

export default NewOrSearchBox;
